import { PciProxyCvv as BasePciProxyCvv } from '@mews/framework';
import { createPciProxyField } from '../../utils/createPciProxyField';

// @ts-expect-error $TSFixMeError: Argument of type 'typeof PciProxyCvv' is not assignable to parameter of type 'ComponentType<{}>'.
export const PciProxyCvv = createPciProxyField(BasePciProxyCvv);
